import React from "react";
import ReactPaginate from "react-paginate";
import styled from "styled-components";

interface PaginateProps {
  pageCount: number;
  forcePage: number;
  handlePageClick: (selected: any) => void;
}

function ReactPaginateWrapper({
  pageCount,
  handlePageClick,
  forcePage,
}: PaginateProps) {
  return (
    <Style>
      <ReactPaginate
        nextLabel={false}
        previousLabel={false}
        onPageChange={handlePageClick}
        pageRangeDisplayed={4}
        marginPagesDisplayed={0}
        pageCount={pageCount}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="break-page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        disableInitialCallback
        renderOnZeroPageCount={null}
        forcePage={forcePage}
      />
    </Style>
  );
}

export default ReactPaginateWrapper;

const Style = styled.div`
  ul,
  li,
  ol,
  a {
    list-style: none;
    cursor: pointer;
  }
  ul {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 0 0 0;
  }
  li {
    margin: 0 12px;

    a {
      padding: 12px;
      font-size: 14px;
      font-weight: 500;
      width: 100%;
      color: #cecece;
    }
  }
  .active {
    a {
      color: #4dd2ae;
    }
  }
  .break-page-item {
    display: none;
  }
`;
